import { gql } from '@apollo/client';

export const GET_ROLES_NO_COMPATIBLES = gql`
    query GetRolNoCompatible($idRol: Int!) {
        rolNoCompatible(idRol: $idRol) {
            success
            error
            valorEsperado {
                idRolNoCompatible
            }
        }
    }
`;